import React, { useContext } from 'react'
import { useTheme } from '@mui/material'
import Tooltip from '@mui/material/Tooltip'
import messagesLib from '../../libs/messages'
import { TEMPLATE_CATEGORY_LABELS, TEMPLATE_CATEGORY_SHORT } from '../../libs/metaTemplates'
import { WabaTemplatesContext } from './context'

// Coluna "Modelo" da lista: só a categoria cabe na largura, então ela é o que
// aparece — o nome do template vai para o tooltip. A categoria não é enfeite:
// Marketing exige opt-in e derruba a qualidade do número, Utilitário é
// transacional e passa fácil. Ver isso ao lado de uma falha já sugere a causa.
//
// Em tela estreita o tooltip não existe (não há hover em toque), então lá o nome
// vem escrito ao lado — por isso a prop `mostrarNome`.

const CORES = {
  MARKETING:      { claro: { fundo: '#efe8fe', texto: '#7c3aed' }, escuro: { fundo: '#2a1f45', texto: '#b191f7' } },
  UTILITY:        { claro: { fundo: '#e4edfd', texto: '#2563eb' }, escuro: { fundo: '#182741', texto: '#7aa8f5' } },
  AUTHENTICATION: { claro: { fundo: '#fdf0dd', texto: '#b45309' }, escuro: { fundo: '#382a14', texto: '#f0a836' } },
  OTP:            { claro: { fundo: '#fdf0dd', texto: '#b45309' }, escuro: { fundo: '#382a14', texto: '#f0a836' } },
}

export default function TemplateCategoryBadge({ message, mostrarNome = false }) {
  const theme = useTheme()
  const templatesByName = useContext(WabaTemplatesContext)

  const dados = messagesLib.getWhatsappCloudApiTemplateData(message.message || '')
  const nome = dados?.templateName
  if (!nome) return null

  // O mapa é indexado em minúsculas (ver Reports/index.jsx).
  const template = templatesByName[String(nome).toLowerCase()]
  const categoria = String(template?.category || '').toUpperCase()
  const sigla = TEMPLATE_CATEGORY_SHORT[categoria]
  const porExtenso = TEMPLATE_CATEGORY_LABELS[categoria]

  const estiloNome = {
    color: theme.isDark ? '#aab6c2' : '#4a5661',
    backgroundColor: theme.isDark ? '#2a2b30' : '#eceff2',
  }

  // Template fora do snapshot (ou sem categoria): não dá pra inventar a sigla.
  // Cai no comportamento antigo — o nome, truncado, com o completo no tooltip.
  if (!sigla) {
    return (
      <Tooltip title={nome}>
        <span
          className="inline-block max-w-full truncate rounded px-1.5 py-0.5 font-mono text-[10px]"
          style={estiloNome}
        >
          {nome}
        </span>
      </Tooltip>
    )
  }

  const cor = CORES[categoria][theme.isDark ? 'escuro' : 'claro']

  const badge = (
    <span
      className="inline-block rounded px-1.5 py-0.5 text-[10px] font-bold tracking-wide whitespace-nowrap flex-none"
      style={{ backgroundColor: cor.fundo, color: cor.texto }}
    >
      {sigla}
    </span>
  )

  if (mostrarNome) {
    return (
      <span className="inline-flex items-center gap-1.5 min-w-0">
        {badge}
        <span className="truncate font-mono text-[10px]" style={{ color: theme.isDark ? '#767c86' : '#85909c' }}>
          {nome}
        </span>
      </span>
    )
  }

  return <Tooltip title={`${nome} · ${porExtenso}`}>{badge}</Tooltip>
}
